var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeskOffice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24667 6.96667V6.48H10.98C11.3933 6.48 11.7267 6.14667 11.7267 5.73333V1.74667C11.7267 1.33333 11.3933 1 10.98 1H5.02C4.60667 1 4.26667 1.33333 4.26667 1.74667V5.72C4.26667 6.13333 4.6 6.46667 5.02 6.46667H6.75333V6.95333H1V10.9533H2V15.9533H3V10.9533H13V15.9533H14V10.9533H15V6.95333H9.24667V6.96667ZM5.27333 5.47333V2H10.7333V5.47333H5.27333ZM7.75333 6.47333H8.24V6.96H7.75333V6.47333ZM14 9.96667H2V7.96667H14V9.96667Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeskOffice);
export default __webpack_public_path__ + "static/media/ic-desk-office.44a4fc657c30f7d5c9dd5624d237bce3.svg";
export { ForwardRef as ReactComponent };